import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import { defaultValue, RanContext } from './ran-context'

import { getRanRooms } from '@portal/kit/pkg/services'


class RanProvider extends Component {
  state = { ...defaultValue }

  loadRanRooms = () => {
    this.setState({ isFetching: true })
    getRanRooms()
      .then(response => {
        const { rooms, can_activate_room: canActivateRan } = response.data
        this.setState({ rooms, canActivateRan, isFetching: false })
      })
      .catch(e => this.setState({ globalError: this.props.t('form.error'), isFetching: false }))
  }

  getRooms = () => {
    // store lastRefreshedAt and refresh every 5min ?
    return this.state.rooms || []
  }

  canActivateRan = () => this.state.canActivateRan

  isFetching = () => this.state.isFetching

  getProviderValue = () => {
    return {
      ...this.state,
      getRooms: this.getRooms,
      loadRanRooms: this.loadRanRooms,
      canActivateRan: this.canActivateRan,
      isFetching: this.isFetching
    }
  }

  componentDidMount() {
    this.loadRanRooms()
  }

  render() {
    return (
      <RanContext.Provider value={this.getProviderValue()}>
        {typeof this.props.children === 'function'
          ? this.props.children(this.state)
          : this.props.children
        }
      </RanContext.Provider>
    )
  }
}

RanProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.node,
  ])
}

export default withTranslation()(RanProvider)
